// One definition of what a subscription status *means* on screen.
//
// Drew, 2026-09-22: every org on the platform is `exempt`, and the Admin Panel
// rendered that as a green pill while an owner opening their own Settings →
// Billing saw it red. `OrgBilling` only knew three states — active, trialing,
// everything-else-is-destructive — so exempt, an entirely good thing, read as
// an alarm to the person it described.
//
// The colours are the operator-console semantics the Admin Panel already used:
//   green  = healthy, nothing owed (active, exempt)
//   amber  = on the clock (trialing)
//   red    = needs money or is blocked (past_due, suspended)
//   gray   = gone (canceled)
//
// Both surfaces read this map, so the two can never disagree again. Sizing is
// left to the caller: the Admin Panel's table wants a 10.5px pill, Billing
// wants a text-sm badge.

export const SUBSCRIPTION_PILL_CLASS: Record<string, string> = {
  active:    'bg-emerald-50 text-emerald-700',
  exempt:    'bg-emerald-50 text-emerald-700',
  trialing:  'bg-amber-50 text-amber-700',
  past_due:  'bg-red-50 text-red-700',
  suspended: 'bg-red-50 text-red-700',
  canceled:  'bg-muted text-muted-foreground',
};

/** An unknown status is neutral, never alarming — a status nobody has styled
 *  yet is not evidence that anything is wrong. */
export const SUBSCRIPTION_PILL_FALLBACK = 'bg-muted text-muted-foreground';

export function subscriptionPillClass(status: string | null | undefined): string {
  return (status && SUBSCRIPTION_PILL_CLASS[status]) || SUBSCRIPTION_PILL_FALLBACK;
}

/** 'past_due' reads as "past due"; everything else is capitalised by CSS. */
export function subscriptionStatusLabel(status: string | null | undefined): string {
  if (!status) return 'Unknown';
  return status === 'exempt' ? 'Exempt' : status.replace('_', ' ');
}
